var _a, _b;
import { __extends } from "tslib";
import { EventDispatcher } from "@awayjs/core";
import { StageEvent } from "@awayjs/stage";
import { RenderEntity } from "./base/RenderEntity";
import { View, ViewEvent, PickGroup } from '@awayjs/view';
import { DefaultRenderer } from './DefaultRenderer';
import { DepthRenderer } from './DepthRenderer';
import { DistanceRenderer } from './DistanceRenderer';
var DefaultRendererPool = /** @class */ (function () {
    function DefaultRendererPool(renderGroup) {
        this._abstractionPool = new Object();
        this._renderGroup = renderGroup;
    }
    Object.defineProperty(DefaultRendererPool.prototype, "materialClassPool", {
        get: function () {
            return DefaultRendererPool._materialClassPool;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * //TODO
     *
     * @param entity
     * @returns EntityNode
     */
    DefaultRendererPool.prototype.getAbstraction = function (partition) {
        return (this._abstractionPool[partition.id] || (this._abstractionPool[partition.id] = new DefaultRenderer(this._renderGroup, partition, this)));
    };
    /**
     *
     * @param entity
     */
    DefaultRendererPool.prototype.clearAbstraction = function (partition) {
        delete this._abstractionPool[partition.id];
    };
    /**
     * Clears the resources used by the RendererPool.
     */
    DefaultRendererPool.prototype.clearAll = function () {
        //clear all renderers associated with this render group
        for (var key in this._abstractionPool)
            this._abstractionPool[key].onClear(null);
    };
    /**
     *
     * @param imageObjectClass
     */
    DefaultRendererPool.registerMaterial = function (renderMaterialClass, materialClass) {
        DefaultRendererPool._materialClassPool[materialClass.assetType] = renderMaterialClass;
    };
    DefaultRendererPool._materialClassPool = new Object();
    return DefaultRendererPool;
}());
var DepthRendererPool = /** @class */ (function () {
    function DepthRendererPool(renderGroup) {
        this._abstractionPool = new Object();
        this._renderGroup = renderGroup;
    }
    Object.defineProperty(DepthRendererPool.prototype, "materialClassPool", {
        get: function () {
            return DepthRendererPool._materialClassPool;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * //TODO
     *
     * @param entity
     * @returns EntityNode
     */
    DepthRendererPool.prototype.getAbstraction = function (partition) {
        return (this._abstractionPool[partition.id] || (this._abstractionPool[partition.id] = new DepthRenderer(this._renderGroup, partition, this)));
    };
    /**
     *
     * @param entity
     */
    DepthRendererPool.prototype.clearAbstraction = function (partition) {
        delete this._abstractionPool[partition.id];
    };
    /**
     * Clears the resources used by the RendererPool.
     */
    DepthRendererPool.prototype.clearAll = function () {
        //clear all renderers associated with this render group
        for (var key in this._abstractionPool)
            this._abstractionPool[key].onClear(null);
    };
    /**
     *
     * @param imageObjectClass
     */
    DepthRendererPool.registerMaterial = function (renderMaterialClass, materialClass) {
        DepthRendererPool._materialClassPool[materialClass.assetType] = renderMaterialClass;
    };
    DepthRendererPool._materialClassPool = new Object();
    return DepthRendererPool;
}());
var DistanceRendererPool = /** @class */ (function () {
    function DistanceRendererPool(renderGroup) {
        this._abstractionPool = new Object();
        this._renderGroup = renderGroup;
    }
    Object.defineProperty(DistanceRendererPool.prototype, "materialClassPool", {
        get: function () {
            return DistanceRendererPool._materialClassPool;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * //TODO
     *
     * @param entity
     * @returns EntityNode
     */
    DistanceRendererPool.prototype.getAbstraction = function (partition) {
        return (this._abstractionPool[partition.id] || (this._abstractionPool[partition.id] = new DistanceRenderer(this._renderGroup, partition, this)));
    };
    /**
     *
     * @param entity
     */
    DistanceRendererPool.prototype.clearAbstraction = function (partition) {
        delete this._abstractionPool[partition.id];
    };
    /**
     * Clears the resources used by the RendererPool.
     */
    DistanceRendererPool.prototype.clearAll = function () {
        //clear all renderers associated with this render group
        for (var key in this._abstractionPool)
            this._abstractionPool[key].onClear(null);
    };
    /**
     *
     * @param imageObjectClass
     */
    DistanceRendererPool.registerMaterial = function (renderMaterialClass, materialClass) {
        DistanceRendererPool._materialClassPool[materialClass.assetType] = renderMaterialClass;
    };
    DistanceRendererPool._materialClassPool = new Object();
    return DistanceRendererPool;
}());
export var RendererType;
(function (RendererType) {
    RendererType[RendererType["DEFAULT"] = 0] = "DEFAULT";
    RendererType[RendererType["DEPTH"] = 1] = "DEPTH";
    RendererType[RendererType["DISTANCE"] = 2] = "DISTANCE";
})(RendererType || (RendererType = {}));
/**
 * @class away.pool.RenderGroup
 */
var RenderGroup = /** @class */ (function (_super) {
    __extends(RenderGroup, _super);
    /**
     * //TODO
     *
     * @param materialClassGL
     */
    function RenderGroup(view, rendererType) {
        var _this = _super.call(this) || this;
        _this._mappers = new Array();
        _this._materialPools = new Object();
        _this._entityPool = new Object();
        _this._view = view;
        _this._stage = view.stage;
        _this._pickGroup = PickGroup.getInstance(view);
        _this._rendererPool = new RenderGroup._rendererClass[rendererType](_this);
        _this._materialClassPool = _this._rendererPool.materialClassPool;
        if (rendererType != RendererType.DEFAULT) //set shadow renderer backgrounds to white
            _this._view.backgroundColor = 0xFFFFFF;
        _this._onSizeInvalidateDelegate = function (event) { return _this.onSizeInvalidate(event); };
        _this._onContextUpdateDelegate = function (event) { return _this.onContextUpdate(event); };
        _this._stage.addEventListener(StageEvent.CONTEXT_CREATED, _this._onContextUpdateDelegate);
        _this._stage.addEventListener(StageEvent.CONTEXT_RECREATED, _this._onContextUpdateDelegate);
        _this._view.addEventListener(ViewEvent.INVALIDATE_SIZE, _this._onSizeInvalidateDelegate);
        return _this;
    }
    RenderGroup.clearAllInstances = function () {
        for (var key in this._instancePool) {
            this._instancePool[key].clearAll();
            delete this._instancePool[key];
        }
    };
    RenderGroup.getInstance = function (view, rendererType) {
        return this._instancePool[rendererType][view.id] || (this._instancePool[rendererType][view.id] = new RenderGroup(view, rendererType));
    };
    RenderGroup.clearInstance = function (view, rendererType) {
        var renderGroup = this._instancePool[rendererType][view.id];
        if (renderGroup) {
            renderGroup.clearAll();
            delete this._instancePool[rendererType][view.id];
        }
    };
    Object.defineProperty(RenderGroup.prototype, "view", {
        get: function () {
            return this._view;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderGroup.prototype, "depthRenderGroup", {
        get: function () {
            if (this._depthRenderGroup == null)
                this._depthRenderGroup = RenderGroup.getInstance(new View(null, this._stage), RendererType.DEPTH);
            return this._depthRenderGroup;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderGroup.prototype, "distanceRenderGroup", {
        get: function () {
            if (this._distanceRenderGroup == null)
                this._distanceRenderGroup = RenderGroup.getInstance(new View(null, this._stage), RendererType.DISTANCE);
            return this._distanceRenderGroup;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderGroup.prototype, "stage", {
        get: function () {
            return this._stage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderGroup.prototype, "pickGroup", {
        get: function () {
            return this._pickGroup;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clears the resources used by the RenderGroup.
     */
    RenderGroup.prototype.clearAll = function () {
        this._stage.removeEventListener(StageEvent.CONTEXT_CREATED, this._onContextUpdateDelegate);
        this._stage.removeEventListener(StageEvent.CONTEXT_RECREATED, this._onContextUpdateDelegate);
        this._view.removeEventListener(ViewEvent.INVALIDATE_SIZE, this._onSizeInvalidateDelegate);
        //clear all entities associated with this render group
        for (var key in this._entityPool)
            this._entityPool[key].onClear(null);
        this._rendererPool.clearAll();
    };
    RenderGroup.prototype.update = function (partition) {
        //update mappers
        var len = this._mappers.length;
        for (var i = 0; i < len; i++)
            this._mappers[i].update(partition, this);
    };
    RenderGroup.prototype.invalidate = function () {
        this._invalid = true;
    };
    RenderGroup.prototype._addMapper = function (mapper) {
        if (this._mappers.indexOf(mapper) != -1)
            return;
        this._mappers.push(mapper);
    };
    RenderGroup.prototype._removeMapper = function (mapper) {
        var index = this._mappers.indexOf(mapper);
        if (index != -1)
            this._mappers.splice(index, 1);
    };
    /**
     *
     */
    RenderGroup.prototype.onSizeInvalidate = function (event) {
        this.dispatchEvent(event);
    };
    /**
     * Assign the context once retrieved
     */
    RenderGroup.prototype.onContextUpdate = function (event) {
        this.dispatchEvent(event);
    };
    RenderGroup.prototype.getRenderElements = function (elements) {
        return this._materialPools[elements.assetType] || (this._materialPools[elements.assetType] = new RenderGroup._renderElementsClassPool[elements.assetType](this._stage, this._materialClassPool, this));
    };
    RenderGroup.prototype.getAbstraction = function (entity) {
        return this._entityPool[entity.id] || (this._entityPool[entity.id] = new RenderEntity(this._stage, entity, this));
    };
    RenderGroup.prototype.getRenderer = function (partition) {
        return this._rendererPool.getAbstraction(partition);
    };
    /**
     *
     * @param entity
     */
    RenderGroup.prototype.clearAbstraction = function (entity) {
        delete this._entityPool[entity.id];
    };
    /**
     *
     * @param imageObjectClass
     */
    RenderGroup.registerElements = function (renderElementsClass, elementsClass) {
        RenderGroup._renderElementsClassPool[elementsClass.assetType] = renderElementsClass;
    };
    RenderGroup.registerDefaultMaterial = function (renderMaterialClass, materialClass) {
        DefaultRendererPool.registerMaterial(renderMaterialClass, materialClass);
    };
    RenderGroup.registerDepthMaterial = function (renderMaterialClass, materialClass) {
        DepthRendererPool.registerMaterial(renderMaterialClass, materialClass);
    };
    RenderGroup.registerDistanceMaterial = function (renderMaterialClass, materialClass) {
        DistanceRendererPool.registerMaterial(renderMaterialClass, materialClass);
    };
    RenderGroup._rendererClass = (_a = {},
        _a[RendererType.DEFAULT] = DefaultRendererPool,
        _a[RendererType.DEPTH] = DepthRendererPool,
        _a[RendererType.DISTANCE] = DistanceRendererPool,
        _a);
    RenderGroup._defaultInstancePool = new Object();
    RenderGroup._depthInstancePool = new Object();
    RenderGroup._distanceInstancePool = new Object();
    RenderGroup._instancePool = (_b = {},
        _b[RendererType.DEFAULT] = RenderGroup._defaultInstancePool,
        _b[RendererType.DEPTH] = RenderGroup._depthInstancePool,
        _b[RendererType.DISTANCE] = RenderGroup._distanceInstancePool,
        _b);
    RenderGroup._renderElementsClassPool = new Object();
    return RenderGroup;
}(EventDispatcher));
export { RenderGroup };
